<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/company/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>企業宗旨、企業理念、事業方針</h1>
        </div>
      </header>
      <HeaderNav activeLink="intro" />
      <!-- main-section -->
      <section class="main-section">
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary">企業宗旨</h2>
            <div>
              <p>
                富地滋自1997年創業以來，最重視的就是人與人之間的連繫。 <br />
                藉由面對面 (Face to Face)
                的直接與人接觸並且傳達核酸營養的健康概念， <br />
                以加強彼此的連繫、深化為他人著想的心，進而結合眾人的感動與信賴。
              </p>
              <p>
                FORDAYS = 累積您的健康，帶給您美麗的人生。 <br />
                富地滋公司的名稱代表著以富裕的心靈和健康的身體，豐富您的人生邁向幸福。
                <br />
                我們以此為基石致力追求健康，並且創造核酸生活，打造一個全新自然的健康環境。
              </p>
              <p>
                富地滋在日本全國各地設立7大會館，並且陸續增設保養所、咖啡館等多處設施，
                <br />
                一方面提供給廣大會員們相互交流分享、深入了解事業機會， <br />
                一方面加深彼此之間的感情羈絆，真正達到 Face to Face 零距離。
                <br />
                此外，擁有專業的研究開發團隊求新求變，走在時代潮流的先端；更設立品質管理中心與自家工場，
                <br />
                秉持著「安全、安心、信賴」的原則，進行全面性的品質保證與一元化管理。
              </p>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary">企業理念</h2>
            <div>
              <h2 class="section-title">
                核酸第一品牌 <br />
                以愛為出發點、以關懷為己任、以助人為志業的企業理念
              </h2>
              <p>
                富地滋致力於細胞營養及核酸進行相關的研究。除了我們所認知的蛋白質、脂質、醣類、維生素、礦物質、食物纖維六大營養素外，核酸則是被稱為第7營養素而備受矚目。
              </p>
              <p>
                2004年，富地滋在台灣成立第一個海外分公司，落地生根成長，並且於台北、台中、高雄均設立會員專用會館。目的就是要透過日本最先端的健康科技，開創台灣核酸品牌新紀元，將核酸營養的健康生活理念貫徹並融入到每個人的日常當中。
              </p>
              <p>
                我們提供優質且不斷進化的產品，量身訂做不同需求的事業經營系統，實現個人自我價值，激發無限潛能，並積極拓展連結海外國際市場，為全球注入生命的曙光。
              </p>
              <p>
                台灣富地滋以人為本，永續經營的發展理念為根基，建立穩固強大的品牌引領市場，更期許建立一個有溫度的大家庭，彼此互相付出、互相成就，帶領每一個人開創健康致富的人生未來，寫下更多感動的故事篇章。
              </p>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary">事業方針</h2>
            <div>
              <div class="company-intro-list">
                <div class="company-intro-list-item">
                  <div class="company-intro-list-item-icon">
                    <img
                      :src="require('@/assets/public/images/company/c_1.png')"
                      alt=""
                      class="w-100"
                    />
                  </div>
                  <div class="company-intro-list-item-title">
                    致力於核酸相關的學術研究與開發，以及情報公開
                  </div>
                </div>
                <div class="company-intro-list-item">
                  <div class="company-intro-list-item-icon">
                    <img
                      :src="require('@/assets/public/images/company/c_2.png')"
                      alt=""
                      class="w-100"
                    />
                  </div>
                  <div class="company-intro-list-item-title">
                    製造並開發高品質產品
                  </div>
                </div>
                <div class="company-intro-list-item">
                  <div class="company-intro-list-item-icon">
                    <img
                      :src="require('@/assets/public/images/company/c_3.png')"
                      alt=""
                      class="w-100"
                    />
                  </div>
                  <div class="company-intro-list-item-title">
                    提供正確的健康情報
                  </div>
                </div>
                <div class="company-intro-list-item">
                  <div class="company-intro-list-item-icon">
                    <img
                      :src="require('@/assets/public/images/company/c_4.png')"
                      alt=""
                      class="w-100"
                    />
                  </div>
                  <div class="company-intro-list-item-title">
                    追求產品的安全、安心
                  </div>
                </div>
                <div class="company-intro-list-item">
                  <div class="company-intro-list-item-icon">
                    <img
                      :src="require('@/assets/public/images/company/c_5.png')"
                      alt=""
                      class="w-100"
                    />
                  </div>
                  <div class="company-intro-list-item-title">
                    提高核酸的社會認知度，傳達與健康相關的啟發活動
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/CompanyHeaderNav";
export default {
  name: "CompanyIntroScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>